function calculatorIframeEvent() {
  window.parent.postMessage('Abrir popup', '*');
}
